import { render, staticRenderFns } from "./NewUserDialog.vue?vue&type=template&id=e57a518c"
import script from "./NewUserDialog.vue?vue&type=script&lang=ts"
export * from "./NewUserDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports